<template>
  <Card :title="name">
    <div v-for="(d, i) in discussionRecord" :key="i">
      <Divider> 记录{{ i + 1 }}</Divider>
      <Field
        v-model="d.time"
        label="时间"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.place"
        label="地点"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.number"
        label="住院号"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.diagnose"
        label="诊断"
        :readonly="readonly"
        placeholder="请输入"
        show-word-limit
        type="textarea"
        maxlength="1000"
        rows="2"
      />
      <Field
        v-model="d.emcee"
        label="主持人"
        :readonly="readonly"
        placeholder="请输入"
      />
      <div class="action" v-if="!readonly">
        <VanBtn
          round
          @click="delRecord(i)"
          :disabled="discussionRecord.length === 1"
          type="danger"
          color="#EA514B"
          size="small"
          >删除</VanBtn
        >
      </div>
    </div>
    <div class="action" v-if="!readonly">
      <VanBtn round type="primary" size="small" @click="addRecord()"
        >添加</VanBtn
      >
    </div>
  </Card>
</template>
<script>
import { Field, Button as VanBtn, Divider } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "DiscussionRecord",
  props: {
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "四、参加病例讨论记录",
      discussionRecord: [
        { time: "", place: "", number: "", diagnose: "", emcee: "" }
      ]
    };
  },
  methods: {
    addRecord() {
      this.discussionRecord.push({
        time: "",
        place: "",
        number: "",
        diagnose: "",
        emcee: ""
      });
    },
    delRecord(index) {
      if (this.discussionRecord.length === 1) {
        return;
      }
      this.discussionRecord.splice(index, 1);
    }
  },
  components: { Card, Field, VanBtn, Divider }
};
</script>
<style lang="scss" scoped>
.action {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  button {
    width: 36%;
  }
}
</style>
